<template>
  <div>
    <div class="footer_wave" :style="marginTop">
      <!-- ../../assets/images/footer-wave.png -->

      <div class="footer_wave_img">
        <svg viewBox="0 0 1449 132" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            :fill="shopifyData.sectionName === 'takat' ? '#384F6B' : '#e9e7e3'"
            d="M700.644 54.4729C325.477 -52.5542 77.2284 22.4837 0 73.381V132H1449V44.5946C1342.69 104.53 1075.81 161.5 700.644 54.4729Z"
          />
        </svg>
      </div>

      <!--<img v-else class="footer_wave_img" v-lazy="(shopifyData.footerWave)" /> -->
    </div>
    <footer class="footer">
      <div class="big_container">
        <div class="footer_content">
          <!-- Footer Link -->
          <ul class="footer_link_list">
            <li v-for="(item, index) in shopifyData.footerMenu" :key="index" class="footer_item">
              <a class="footer_link" :href="item.linkUrl"> {{ item.linkTitle }} </a>
            </li>
            <li class="footer_item follow-journey">
              <span class="footer_link">FOLLOW OUR JOURNEY</span>
              <div class="footer_social_link">
                <a
                  class="link"
                  target="_blank"
                  href="https://www.facebook.com/behno-461960733987428/?fref=ts&ref=br_tf"
                >
                  <img
                    v-lazy="shopifyData.fbIcon"
                    alt="Facebook Icon"
                    loading="lazy"
                    aria-label="Facebook Icon"
                    width="17"
                    height="17"
                  />
                </a>
                <a class="link" target="_blank" href="https://www.instagram.com/behno_official/">
                  <img
                    v-lazy="shopifyData.instaIcon"
                    alt="Instagram Icon"
                    loading="lazy"
                    aria-label="Instagram Icon"
                    width="17"
                    height="17"
                  />
                </a>
              </div>
            </li>
            <li class="footer_item">
              <span class="footer_link">BEHNO LLC</span>
            </li>
          </ul>
          <!-- Footer Form -->
          <div class="footer_form">
            <h3 class="footer_form_heading">
              STAY IN TOUCH.
              <span> &nbsp;{{ shopifyData.stayTouch }} </span>
            </h3>
            <!-- klaviyo form  -->
            <div id="subscribe" class="klaviyo-form-TzvfPL" />
            <!-- klaviyo form  -->
            <!-- <form
              action=""
              class="email_form"
            >
              <input
                id="footeremail"
                class="footer_input"
                type="email"
                placeholder="Enter your email address"
              >
              <button
                type="submit"
                class="footer_form_btn"
              >
                SUBSCRIBE
              </button>
            </form> -->
            <h4 class="footer_after_pay">
              <!-- ../../assets/svg/after-icon.svg -->
              <img
                v-lazy="shopifyData.afterIcon"
                alt="Afterpay Icon"
                loading="lazy"
                aria-label="Afterpay Icon"
                width="69"
                height="12"
              />
              <span> {{ shopifyData.afterpay }} </span>
            </h4>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    marginTop() {
      return {
        'margin-top':
          window.innerWidth > 768
            ? `${this.shopifyData.deskMarginTop}px`
            : `${this.shopifyData.mobMarginTop}px`,
      };
    },
  },
};
</script>

<style>
/* clavio form css */
form.needsclick {
  border-bottom: 1px solid #000 !important;
  border-radius: 0 !important;
  margin: 27px 0 38px !important;
}

input.needsclick.go2349912704.kl-private-reset-css-Xuajs1 {
  padding: 0 !important;
}

input#email_51927345 {
  border: 0 !important;
  height: auto !important;
  padding: 5px 0 !important;
}
input#email_51927345:focus-visible {
  outline-width: 0px !important;
  outline-style: auto;
  outline-color: transparent !important;
  outline-offset: 0;
}
input#email_51927345:-internal-autofill-selected {
  appearance: menulist-button;
  background-image: none !important;
  background-color: light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4)) !important;
  background-color: red !important;
  color: fieldtext !important;
}

input#email_51927345:focus {
  box-shadow: inset 0 0 0px 25px #e9e7e3 !important;
}

button.needsclick:focus {
  box-shadow: none !important;
}

button.needsclick {
  padding: 5px 0 !important;
}

/* clavio form css */

/* Warning Css Code */
.common_warning {
  box-shadow: 0px 5px 10px rgba(90, 116, 148, 0.3);
  padding: 20px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  max-width: 500px;
  width: 100%;
  position: fixed;
  z-index: 10;
  bottom: 50px;
  right: 50px;
  transform: translateY(-20%);
  gap: 10px;
  background: #fff;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
}

.common_warning.warning.active,
.common_warning.error.active,
.common_warning.success.active {
  transform: translateY(-50%);
  background: #fff;
  opacity: 1;

  visibility: visible;
}

.common_warning.warning path {
  fill: #ffc107;
}

.common_warning.warning span {
  color: #ffc107;
  line-height: 1;
}

.common_warning.error path {
  fill: red;
}

.common_warning.error span {
  color: red;
  line-height: 1;
}

.common_warning.success path {
  fill: green;
}

.common_warning.success span {
  color: green;
  line-height: 1;
}

/* Footer Css Code */
.footer_wave {
  line-height: 0;
  margin-bottom: -2px;
}

.footer_wave_img {
  line-height: 0;
  width: 100%;
}

.footer {
  padding: 70px 0 76px;
  background-color: #e9e7e3;
  margin-top: -0.5px;
}

.footer .big_container {
  /* max-width: 1320px; */
  padding: 0 20px;
}

.footer .footer_link_list {
  width: fit-content;
  margin: 0 auto;
}

.footer .footer_form {
  width: 530px;
  margin: 0 auto;
}

.footer_content {
  display: flex;
  /* grid-template-columns: 1fr minmax(auto, 530px); */
  gap: 75px 30px;
  /* justify-content: space-between; */
  align-items: center;
}

.footer_link {
  color: #000000;
  font-weight: 700;
  font-size: 14px;
  line-height: 1;
}

@media (hover: hover) {
  .footer_link:hover {
    text-decoration: underline;
  }

  span.footer_link:hover {
    text-decoration: initial;
  }
}

.footer_item.follow-journey,
.footer_social_link {
  display: flex;
  align-items: center;
  gap: 18px;
}

.footer_item {
  margin-bottom: 12px;
  line-height: 0;
}

.footer_item:last-child {
  margin-bottom: 0px;
}

.footer_social_link .link {
  display: flex;
  align-items: center;
}

/* Footer Form css Code */
.footer_form_heading {
  font-size: 12px;
  line-height: 14px;
  color: #000;
}

.footer_form_heading span {
  font-weight: 400;
}

.email_form {
  display: flex;
  border-bottom: 1px solid #000000 !important;
  margin: 27px 0 38px !important;
}

.footer_input::placeholder,
.footer_input,
#email_11141536 {
  color: #5c5c5c !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 14px !important;
}

.footer_input,
#email_11141536 {
  background-color: transparent !important;
  border: none !important;
  width: 100%;
  padding: 0 10px 4px 0 !important;
  outline: none;
}

.footer_form_btn {
  color: #5c5c5c;
  font-weight: 700;
  font-size: 12px;
}

.footer_after_pay {
  display: flex;
  align-items: center;
}

.footer_after_pay span {
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
}

/* RESPONSIVE BREAKPOINTS */
@media (max-width: 1320px) {
  .footer_content .footer_link_list {
    max-width: fit-content;
    margin: 0 auto;
  }

  .footer_content .footer_form {
    max-width: 440px;
    margin: 0 auto;
  }
}

@media only screen and (max-width: 991px) {
  .footer_content {
    grid-template-columns: 1fr 1fr;
  }
}

@media only screen and (max-width: 768px) {
  .footer {
    padding: 30px 0 30px;
  }

  .footer_content {
    flex-direction: column-reverse;
    gap: 64px 30px;
  }

  .footer_content .footer_link_list {
    max-width: 100%;
    margin: 0;
  }

  .footer_content .footer_form,
  .footer_content .footer_link_list {
    max-width: 100%;
    width: 100%;
    margin: 0;
  }

  .footer_form {
    grid-row-start: -1;
    max-width: 500px;
  }
}
</style>
